import dayjs, { Dayjs } from "dayjs";

export type SearchFunction = (row: any, searchedValue: string, statusFilter?: string) => boolean;

export const getCurrencySymbol = (currency: string): string => {
  switch (currency) {
    case "USD":
      return "$";
    case "EUR":
      return "€";
    case "GBP":
      return "£";
    case "JPY":
      return "¥";
    case "INR":
      return "₹";
    default:
      return currency;
  }
};

export const defaultSearchFunction: SearchFunction = (row, searchedValue) => {
  if (searchedValue === "") {
    return true;
  }

  const normalizedSearchedValue = searchedValue.replace(/\s+/g, "").toLowerCase();

  return Object.values(row).some((value: any) => {
    if (value) {
      const normalizedValue = value.toString().replace(/\s+/g, "").toLowerCase();
      return normalizedValue.includes(normalizedSearchedValue);
    }
    return false;
  });
};


export const searchWithStatusFilter: SearchFunction = (row, searchedValue, statusFilter) => {
  if (!searchedValue && !statusFilter) {
    return true;
  }
  if (statusFilter === "ALL" || statusFilter === "ALLORDERS" || statusFilter === "ALLGRN" || !statusFilter) {
    return Object.values(row).some((value: any) =>
      value?.toString().toLowerCase().includes(searchedValue.toLowerCase())
    );
  }

  if (!searchedValue && statusFilter) {
    return (
      row.status?.toLowerCase() === statusFilter.toLowerCase() ||
      row?.grnStatus?.toLowerCase() === statusFilter.toLowerCase()
    );
  }

  const matchesStatus =
    row.status?.toLowerCase().includes(statusFilter.toLowerCase()) ||
    row?.grnStatus?.toLowerCase().includes(statusFilter.toLowerCase());
  const matchesSearchedValue = Object.values(row).some((value: any) =>
    value?.toString().toLowerCase().includes(searchedValue.toLowerCase())
  );

  return matchesStatus && matchesSearchedValue;
};

export const filterData = (
  data: any[],
  searchedValue: string,
  searchFunction: SearchFunction,
  statusFilter?: string
): any[] => {
  const statuses: string[] = statusFilter?.split(",") ?? [];

  if(statuses.length === 0) {
    return data.filter((row) => searchFunction(row, searchedValue, statusFilter));
  }

  const res: any[] = [];
  for (const s of statuses) {
    const filtered = data.filter(row => searchFunction(row, searchedValue, s));
    res.push(...filtered);
  }

  return res;
};

export const updateDatesInLocalStorage = (
  start: Dayjs,
  end: Dayjs,
  navbarParentLabel: string,
  pageID: string
) => {
  const storedData = localStorage.getItem(navbarParentLabel?.toLowerCase());
  const parsedData = storedData ? JSON.parse(storedData) : {};

  parsedData[pageID] = {
    startDate: start.toISOString(),
    endDate: end.toISOString(),
  };

  localStorage.setItem(navbarParentLabel?.toLowerCase(), JSON.stringify(parsedData));
};

export const getDatesFromLocalStorage = (navbarParentLabel: string, pageID: string, defaultInterval?:number) => {
  const storedData = localStorage.getItem(navbarParentLabel?.toLowerCase());

  if (storedData) {
    const parsedData = JSON.parse(storedData);
    if (parsedData[pageID]) {
      return {
        startDate: dayjs(parsedData[pageID].startDate),
        endDate: dayjs(parsedData[pageID].endDate),
      };
    } else {
      // updateDatesInLocalStorage(dayjs(), dayjs(), navbarParentLabel?.toLowerCase(), pageID);
      return {
        startDate: defaultInterval ? dayjs().subtract(defaultInterval, 'day') : dayjs(),
        endDate: dayjs(),
      };
    }
  }
   else {
    // updateDatesInLocalStorage(dayjs(), dayjs(), navbarParentLabel?.toLowerCase(), pageID);
    return {
      startDate: defaultInterval ? dayjs().subtract(defaultInterval, 'day') : dayjs(),
      endDate: dayjs(),
    };
  }
};

export const removeDatesFromLocalStorage = (activeNavbarParentLabel: string) => {
  const navbarParentLabels = ["sale", "purchase"];
  navbarParentLabels.map((label) => {
    if (label.toLowerCase() != activeNavbarParentLabel.toLowerCase()) {
      localStorage.removeItem(label?.toLowerCase());
    }
  });
};


export const getMultipleFilterBasedData = (
  data: any,
  selectedFilters: Record<string, string[]>,
  filterKeys: string[]
) => {
  return data.filter((order: any) => {
    return filterKeys.every((key) => {
      const orderValue = order[key]?.toLowerCase();
      const selectedValues = selectedFilters[key] || [];
      return selectedValues.length === 0 || selectedValues.some((filter) => filter.toLowerCase() === orderValue);
    });
  });
};

